"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Message = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 20px;\n  background: transparent;\n  box-sizing: border-box;\n  padding-top: 4px;\n  font-size: 13px;\n  color: ", ";\n\n  &:focus {\n    outline: 0;\n  }\n"], ["\n  width: 100%;\n  height: 20px;\n  background: transparent;\n  box-sizing: border-box;\n  padding-top: 4px;\n  font-size: 13px;\n  color: ", ";\n\n  &:focus {\n    outline: 0;\n  }\n"])), function (props) { return props.error ? props.theme.colors.red2 : props.theme.colors.tableGray1; });
var templateObject_1;
